import React from "react";
import PropTypes from "prop-types";


import SelectInput from "../../common/SelectInput";
import Row from "../../common/Row";


import * as domainConstants from "../../../constants/DomainConstants";
import DownloadUploadFiles from "../../common/DownloadUploadFiles";

const EigendomsrechtAanvragerForm = (props) => {
	const {
		disabled,
		errors,
		aanvragers,
		onChange,
		minimaleEisen,
		color,
		mapDeleteFile,
		mapDropFiles,
		getFilesForDossierComponent,
		fileTypes,
		fileSessionStarted,
		defaultAanvrager,
		validationMessageType
	} = props;

	return (
		<Row>
			<Row>
				{defaultAanvrager === null ?
					<SelectInput
						label="Titularis"
						name="titularisId"
						onChange={onChange}
						value={minimaleEisen.titularisId}
						disabled={disabled}
						items={aanvragers}
						validationMessage={errors ? errors.titularisId : ''}
						validationMessageType={validationMessageType} /> :
					<SelectInput
						label="Titularis"
						name="titularisId"
						onChange={onChange}
						value={minimaleEisen.titularisId}
						disabled={disabled}
						items={[]}
						defaultItem={defaultAanvrager.label}
						validationMessage={errors ? errors.titularisId : ''}
						validationMessageType={validationMessageType} />}
			</Row>
			<Row>
				<DownloadUploadFiles
					dossierId={minimaleEisen.dossierId}
					infrastructuurId={minimaleEisen.infrastructuur.id}
					title="Bewijs van eigendom"
					center
					disabled={disabled}
					color={color}
					tab={domainConstants.DocumentTab.MinimaleEisen}
					component={domainConstants.ComponentName.BewijsEigendom}
					onDelete={mapDeleteFile(domainConstants.ComponentName.BewijsEigendom)}
					onDrop={mapDropFiles(domainConstants.ComponentName.BewijsEigendom)}
					files={getFilesForDossierComponent(domainConstants.ComponentName.BewijsEigendom)}
					fileTypes={fileTypes.BewijsEigendom}
					validationMessage={errors ? errors.ulEigendomsrecht : ''}
					validationMessageType={validationMessageType}
					fileSessionStarted={fileSessionStarted} />
			</Row>
		</Row>
	);
};

// ----------------------------------------------------------------------------
EigendomsrechtAanvragerForm.propTypes = {
	disabled: PropTypes.bool,
	errors: PropTypes.object,
	aanvragers: PropTypes.arrayOf(PropTypes.object),
	onChange: PropTypes.func,
	minimaleEisen: PropTypes.object.isRequired,
	color: PropTypes.string.isRequired,
	mapDeleteFile: PropTypes.func,
	mapDropFiles: PropTypes.func,
	getFilesForDossierComponent: PropTypes.func,
	fileTypes: PropTypes.object,
	fileSessionStarted: PropTypes.bool.isRequired,
	defaultAanvrager: PropTypes.object,
	validationMessageType: PropTypes.string
};

export default EigendomsrechtAanvragerForm;
